module.exports = __webpack_public_path__ + "img/29_63.c0b71084.png";